import Marquee from "react-fast-marquee";
import { useLang } from "../../i18n";

export const ServiceMarquee = () => {
  const { c } = useLang();
  return (
    <section data-testid="marquee" className="py-10 md:py-14 border-y border-[var(--border)] bg-[var(--bg-secondary)] relative z-10">
      <Marquee speed={40} gradient={false} autoFill>
        {c.marquee.map((item) => (
          <div key={item} className="flex items-center">
            <span className="font-serif text-3xl md:text-5xl tracking-tight text-[var(--text-primary)] px-8 md:px-12">
              {item}
            </span>
            <span className="text-[var(--accent)] text-2xl md:text-4xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
